<div class="topbar-menu-nav-buttons">
  <ng-content></ng-content>
</div>
